<div class="container-fluid container-fluid--dashboard ps-4 pe-4">
  <div class="d-flex pt-3" *ngIf="learnpathsFiltered">
    <div class="dashboard flex-shrink-0" style="width: 350px; margin-right: 20px">
      <div class="filter" style="min-height: 700px">
        <h2 style="margin-top: 0; padding-top: 0; text-transform: uppercase">{{ 'search_filter' | label : 'lms' | async }}</h2>
        <!-- Zoekfilter op naam -->
        <div class="row">
          <div class="col-12">
            <input type="search" class="form-control" aria-describedby="learninpath-search" [(ngModel)]="learningpathSearch" (keydown)="iterator()" (keyup)="iterator()" (change)="iterator()" (search)="iterator()" (blur)="iterator()" placeholder="{{ 'search_learningpath' | label : 'learningpath' | async }}" />
          </div>
        </div>
        <!-- Zoekfilter: enkel actieve leerpaden vs. enkel inactieve -->
        <div class="form-check mt-3" *ngIf="isHR">
          <input class="form-check-input" type="checkbox" id="showActiveLearnpaths" [(ngModel)]="showActiveLearnpaths" (change)="iterator()" />
          <label class="form-check-label" for="showActiveLearnpaths">
            <i class="fas fa-play-circle fa-fw fixed-icon" style="color: green"></i>
            <span style="margin-left: 5px">{{ 'active_learningpaths' | label : 'learningpath' | async }}</span>
          </label>
        </div>

        <div class="form-check" *ngIf="isHR">
          <input class="form-check-input" type="checkbox" id="showInactiveLearnpaths" [(ngModel)]="showInactiveLearnpaths" (change)="iterator()" />
          <label class="form-check-label" for="showInactiveLearnpaths">
            <i class="fas fa-play-circle fa-fw fixed-icon" style="color: grey"></i>
            <span style="margin-left: 5px">{{ 'inactive_learningpaths' | label : 'learningpath' | async }}</span>
          </label>
        </div>

        <!-- Zoekfilter: enkel leerpaden met inschrijvingen vs. enkel zonder -->
        <div class="form-check mt-3">
          <input class="form-check-input" type="checkbox" id="showLearnpathsWithParticipants" [(ngModel)]="showLearnpathsWithParticipants" (change)="iterator()" />
          <label class="form-check-label" for="showLearnpathsWithParticipants">
            <i class="fas fa-users fa-fw fixed-icon"></i>
            <span style="margin-left: 5px">{{ 'learningpaths_with_participants' | label : 'learningpath' | async }}</span>
          </label>
        </div>

        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="showLearnpathsWithoutParticipants" [(ngModel)]="showLearnpathsWithoutParticipants" (change)="iterator()" />
          <label class="form-check-label" for="showLearnpathsWithoutParticipants">
            <i class="fas fa-users-slash fa-fw fixed-icon"></i>
            <span style="margin-left: 5px">{{ 'learningpaths_without_participants' | label : 'learningpath' | async }}</span>
          </label>
        </div>

        <hr class="mb-4" />
        <h3 style="font-weight: bold">
          <span *ngIf="learnpathsFiltered.length != 1">{{ learnpathsFiltered.length }} {{ 'learningpaths_found' | label : 'learningpath' | async }}</span>
          <span *ngIf="learnpathsFiltered.length == 1">{{ learnpathsFiltered.length }} {{ 'learningpath_found' | label : 'learningpath' | async }}</span>
        </h3>

        <div class="learnpath-selector-container">
          <div class="d-flex learnpath-activity-selectors pt-4 pb-4 pe-0 cursor-pointer align-items-center" *ngFor="let learnpath of learnpathsFiltered; index as learnpathindex; let last = last" [ngClass]="{ active: activeLearnpath == learnpath }" (click)="selectLearnPath($event, learnpath, View.Employees)">
            <div class="cursor-pointer">
              <app-circle-image [photo]="learnpath.coursePhoto" [text]="learnpath.name" [width]="35" [style.width.px]="35"> </app-circle-image>
            </div>
            <div class="ms-3 me-3">
              <i class="fas fa-exclamation text-danger" *ngIf="learnpath.actionsRequired > 0"></i>
            </div>
            <div class="flex-grow-1">
              <h6 class="cursor-pointer">
                {{ learnpath.name }}
              </h6>
              <div class="d-flex">
                <div class="flex-grow-1">
                  {{ learnpath.studentCount }}
                  {{ 'medewerker(s)' | label : 'learningpath' | async }}
                </div>
                <div class="buttons">
                  <div class="btn-group" role="group">
                    <button type="button" class="btn" ngbTooltip="{{ 'information' | label : 'learningpath' | async }}" placement="top" container="body" (click)="selectLearnPath($event, learnpath, View.Info)">
                      <i class="fas fa-info-circle"></i>
                    </button>
                    <button type="button" class="btn" ngbTooltip="{{ (isHR ? 'registerstudents' : 'registerTeamMembers') | label : 'learningpath' | async }}" placement="top" container="body" (click)="selectLearnPath($event, learnpath, View.Enroll)">
                      <i class="fas fa-plus-circle"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- learningpath content -->
    <div class="flex-grow-1 overflow-x-hidden" *ngIf="activeLearnpath && activeView === View.Info">
      <div *ngIf="activeLearnpath != null">
        <div class="row">
          <div class="col-8">
            <div class="pt-3 pb-0 ps-0 pe-0 moduleTitle">
              <div class="row">
                <div class="w80">
                  <app-circle-image [photo]="activeLearnpath.coursePhoto" [text]="activeLearnpath.name" [width]="60" [style.width.px]="60"> </app-circle-image>
                </div>
                <div class="col-8">
                  <h1 class="mb-0 pb-0">{{ activeLearnpath.name }}</h1>
                </div>
              </div>
            </div>
          </div>
          <div class="col-8">
            <div class="">
              <div class="row mb-5">
                <div class="w80"></div>
                <div class="col-8 ps-0">
                  <div [innerHTML]="activeLearnpath.details | safeHTML"></div>
                </div>
              </div>
              <ng-container *ngIf="activities$ | async as activities">
                <div class="pt-0 ps-0 pe-0 mb-4" *ngFor="let activity of activities">
                  <div class="row">
                    <div class="d-flex justify-content-end w80">
                      <app-circle-image [photo]="activity.coursePhoto" [text]="activity.name" [width]="35"> </app-circle-image>
                    </div>
                    <div class="col-8">
                      <h2 class="mb-2">{{ activity.name }} {{ activity.typeName }}</h2>
                      <div [innerHTML]="activity.description | safeHTML"></div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex-grow-1" *ngIf="activeLearnpath && activeView === View.Employees">
      <div class="row ps-2 pe-2 mb-4" *ngIf="activeLearnpath.availableDays > 0 && false">
        <div class="position-relative" style="width: 140px">
          <div class="donutDiv" #chartContainer [style.height.px]="dynHeight" *ngIf="pieChartData && pieChartData.length > 0">
            <canvas #chart baseChart [datasets]="pieChartData" [options]="pieChartOptions" [legend]="pieChartLegend" [type]="pieChartType"> </canvas>
            <div class="tooltip fade" data-bs-toggle="tooltip" data-bs-placement="top" #chartTooltip></div>
          </div>
          <app-legend [legends]="legends"></app-legend>
        </div>
      </div>

      <h1 class="pb-3">{{ 'participants_of_learningpath' | label : 'learningpath' | async }}: {{ activeLearnpath.name }}</h1>

      <app-learning-path-employee-overview [inputLearnpathId]="activeLearnpath.learningPathId" [deadline]="activeLearnpath.availableDays > 0"> </app-learning-path-employee-overview>
    </div>

    <div class="flex-grow-1" *ngIf="activeLearnpath && activeView === View.Enroll">
      <app-learning-path-employee-dashboard [inputLearnpathId]="activeLearnpath.learningPathId"> </app-learning-path-employee-dashboard>
    </div>
  </div>
</div>
